export enum PictogramType {
  _10_year_guarantee = '10_year_guarantee',
  _5YearGuarantee = '5YearGuarantee',
  _8YearGuarantee = '8YearGuarantee',
  _9houseConstructor = '9houseConstructor',
  Ab1 = 'Ab1',
  Ab2 = 'Ab2',
  Accoustic = 'Accoustic',
  AccessPanels = 'AccessPanels',
  Accessories = 'Accessories',
  AdhesivesFinishing = 'AdhesivesFinishing',
  Aesthetic = 'Aesthetic',
  AestheticPrefab = 'AestheticPrefab',
  AirQuality = 'AirQuality',
  Alert = 'Alert',
  Analytics = 'Analytics',
  AnchoredLinnings = 'AnchoredLinnings',
  Architect = 'Architect',
  Arable = 'Arable',
  AskAQuestion = 'AskAQuestion',
  Asterisk = 'Asterisk',
  Attachment = 'Attachment',
  Avatar = 'Avatar',
  Award = 'Award',
  Award2 = 'Award2',
  Bag = 'Bag',
  Barrier = 'Barrier',
  Bathroom = 'Bathroom',
  Bedroom = 'Bedroom',
  BenefitFungalChemicalResistant = 'BenefitFungalChemicalResistant',
  BIM = 'BIM',
  Boards = 'Boards',
  Burglary = 'Burglary',
  Cad = 'Cad',
  CalculatorsAndTools = 'CalculatorsAndTools',
  Careers = 'Careers',
  CaseStudy = 'CaseStudy',
  Ceiling = 'Ceiling',
  Cellar = 'Cellar',
  CementBoard = 'CementBoard',
  Certificates = 'Certificates',
  Check = 'Check',
  Checkmark = 'Checkmark',
  CeramicGypsum = 'CeramicGypsum',
  Clock = 'Clock',
  Colour = 'Colour',
  Colourrange = 'Colourrange',
  ColourSwatches = 'ColourSwatches',
  CompartmentationSector = 'CompartmentationSector',
  Compounds = 'Compounds',
  Cone = 'Cone',
  Connect = 'Connect',
  Connection = 'Connection',
  ContactCenter = 'ContactCenter',
  Conversation = 'Conversation',
  CorporateBrochures = 'CorporateBrochures',
  Cross = 'Cross',
  CurrentLocation = 'CurrentLocation',
  CustomerService = 'CustomerService',
  DairyCattle = 'DairyCattle',
  Decorator = 'Decorator',
  Design = 'Design',
  DesignChoices = 'DesignChoices',
  DesignFlexibility = 'DesignFlexibility',
  Desktop = 'Desktop',
  DiningRoom = 'DiningRoom',
  Distributor = 'Distributor',
  Diy = 'Diy',
  DocAdd = 'DocAdd',
  DocCheck = 'DocCheck',
  DocSearch = 'DocSearch',
  Drill = 'Drill',
  Durable = 'Durable',
  DurableStrong = 'DurableStrong',
  Dwg = 'Dwg',
  EasyDismantle = 'EasyDismantle',
  EasyFit = 'EasyFit',
  EasyInstall = 'EasyInstall',
  Earth = 'Earth',
  Education = 'Education',
  Ehbo = 'Ehbo',
  EngagedPeople = 'EngagedPeople',
  Encasement = 'Encasement',
  Environment = 'Environment',
  Equestrian = 'Equestrian',
  Excellence = 'Excellence',
  Exteriors = 'Exteriors',
  Factory = 'Factory',
  Fairs = 'Fairs',
  FamillyRoom = 'FamillyRoom',
  FAQ = 'Faq',
  Faq = 'Faq',
  Fire = 'Fire',
  Fireplaces = 'Fireplace',
  Fireproof = 'Fireproof',
  FireProtectionSector = 'FireProtectionSector',
  Firestopping = 'Firestopping',
  FirestoppingSector = 'FirestoppingSector',
  Finishing = 'Finishing',
  Flag = 'Flag',
  Floor = 'Floor',
  FrameConstruction = 'FrameConstruction',
  Frost = 'Frost',
  Garage = 'Garage',
  General = 'General',
  GenericDocument = 'GenericDocument',
  Glass = 'Glass',
  GlassSector = 'GlassSector',
  Glove = 'Glove',
  Gloves = 'Gloves',
  Glossary = 'Glossary',
  Graph = 'Graph',
  GridView = 'GridView',
  Guarantee = 'Guarantee',
  GuaranteeCertified = 'GuaranteeCertified',
  GypsumBlocks = 'GypsumBlocks',
  Hallways = 'Hallways',
  Hardhat = 'Hardhat',
  Heart = 'Heart',
  HeathlossReduction = 'HeathlossReduction',
  Healthcare = 'Healthcare',
  Help = 'Help',
  HighDimensions = 'HighDimensions',
  Home = 'Home',
  HomeOffice = 'HomeOffice',
  Honeycomb = 'Honeycomb',
  Hotel = 'Hotel',
  Hourglass = 'Hourglass',
  Impact = 'Impact',
  Impact2 = 'Impact2',
  IncreasedCapacity = 'IncreasedCapacity',
  Industrial = 'Industrial',
  Innovation = 'Innovation',
  Innovation3D = 'Innovation3D',
  InspectionDoorsFlaps = 'InspectionDoorsFlaps',
  Installer = 'Installer',
  InstallationAndConstructionInfo = 'InstallationAndConstructionInfo',
  InstallationInstructions = 'InstallationInstructions',
  Insulation = 'Insulation',
  IntumescentPaints = 'IntumescentPaints',
  KerbAppeal = 'KerbAppeal',
  Kitchen = 'Kitchen',
  Left_arrow3D = 'Left_arrow3D',
  LegislationAndRegulations = 'LegislationAndRegulations',
  Leisure = 'Leisure',
  Lift = 'Lift',
  Lightbulb = 'Lightbulb',
  Like = 'Like',
  Lightweight = 'Lightweight',
  Lightweight2 = 'Lightweight2',
  ListView = 'ListView',
  LivingRoom = 'LivingRoom',
  Load = 'Load',
  Location2 = 'Location2',
  Loft = 'Loft',
  Longevity = 'Longevity',
  LowMaintenance = 'LowMaintenance',
  LowMaintenance2 = 'LowMaintenance2',
  LowMaterialUsage = 'LowMaterialUsage',
  Machanical = 'Machanical',
  MachineryStorage = 'MachineryStorage',
  MainContractor = 'MainContractor',
  Maintenance = 'Maintenance',
  Map = 'Map',
  MapView = 'MapView',
  ManualApplication = 'ManualApplication',
  Manufacturer = 'Manufacturer',
  MetalFrames = 'MetalFrames',
  Modular = 'Modular',
  ModularCeilings = 'ModularCeilings',
  MoreStableThanWood = 'MoreStableThanWood',
  Mouse = 'Mouse',
  Mouse2 = 'Mouse2',
  Muster = 'Muster',
  NonFlammable = 'NonFlammable',
  NonSlip = 'NonSlip',
  NoPainting = 'NoPainting',
  NoResults = 'NoResults',
  Offices = 'Offices',
  OperationalExcellence = 'OperationalExcellence',
  Paint = 'Paint',
  Partition = 'Partition',
  People = 'People',
  People2 = 'People2',
  Performance3D = 'Performance3D',
  Ph2 = 'Ph2',
  Photo = 'Photo',
  Pig = 'Pig',
  Piggybank = 'Piggybank',
  Pin = 'Pin',
  Plasterboard = 'Plasterboard',
  Plasters = 'Plasters',
  Planning = 'Planning',
  Poultry = 'Poultry',
  PrefabricatedProducts = 'PrefabricatedProducts',
  Press = 'Press',
  ProductLitatature = 'ProductLitatature',
  ProjectCertifications = 'ProjectCertifications',
  ProtectedDocument = 'ProtectedDocument',
  Protection = 'Protection',
  Public = 'Public',
  Racking = 'Racking',
  Receive = 'Receive',
  Recycling = 'Recycling',
  Remarks = 'Remarks',
  Residential = 'Residential',
  Retail = 'Retail',
  Right_arrow3D = 'Right_arrow3D',
  Rocket = 'Rocket',
  RotResistant = 'RotResistant',
  Rustproof = 'Rustproof',
  SafeReliable = 'SafeReliable',
  Safety = 'Safety',
  Sales = 'Sales',
  SavingCost = 'SavingCost',
  Screwdriver = 'Screwdriver',
  Sealants = 'Sealants',
  Search = 'Search',
  Seismic = 'Seismic',
  SelfBearingCeilings = 'SelfBearingCeilings',
  ServiceRoom = 'ServiceRoom',
  Settings = 'Settings',
  Shaftwall = 'Shaftwall',
  ShaftwallSteel = 'ShaftwallSteel',
  SheepAndgoats = 'SheepAndgoats',
  Shuffle = 'Shuffle',
  SmallBuilder = 'SmallBuilder',
  SoftUnderground = 'SoftUnderground',
  Sound = 'Sound',
  Soundproof = 'Soundproof',
  Spade = 'Spade',
  Speaker = 'Speaker',
  SprayCoatings = 'SprayCoatings',
  Stability = 'Stability',
  Static = 'Static',
  Stop = 'Stop',
  StudentAcommodation = 'StudentAcommodation',
  Subsidies = 'Subsidies',
  SupportWarranty = 'SupportWarranty',
  SuspendedCeilings = 'SuspendedCeilings',
  Sustainability = 'Sustainability',
  Sustainability3D = 'Sustainability3D',
  SustainabilityEnvironment = 'SustainabilityEnvironment',
  SustainableLonglife = 'SustainableLonglife',
  Switchboard = 'Switchboard',
  SystemSelector = 'SystemSelector',
  Target = 'Target',
  Teamwork = 'Teamwork',
  TechicalBrochures = 'TechicalBrochures',
  TechnicalDataSheets = 'TechnicalDataSheets',
  TechnicalDucts = 'TechnicalDucts',
  TechnicalSupport = 'TechnicalSupport',
  TertiaryFix = 'TertiaryFix',
  Thermal = 'Thermal',
  ThermalInsulation = 'ThermalInsulation',
  Thumbsdown = 'Thumbsdown',
  Thumbsup = 'Thumbsup',
  Timer = 'Timer',
  TimberStructure = 'TimberStructure',
  TongueAndGroove = 'TongueAndGroove',
  Tools = 'Tools',
  Transportation = 'Transportation',
  Troughwall = 'Troughwall',
  TunnelSector = 'TunnelSector',
  UnLike = 'UnLike',
  Up_arrow3D = 'Up_arrow3D',
  UserRegistered = 'UserRegistered',
  UvResistant = 'UvResistant',
  Ventilation = 'Ventilation',
  VentilationDucts = 'VentilationDucts',
  VentilationSector = 'VentilationSector',
  Video = 'Video',
  Videos = 'Videos',
  Viticulture = 'Viticulture',
  Warning = 'Warning',
  WasteManagement = 'WasteManagement',
  Water = 'Water',
  WaterResistant = 'WaterResistant',
  Weight = 'Weight',
  WithoutTape = 'WithoutTape',
}

export interface PictogramProps {
  pictogramType: PictogramType;
  className?: string;
}

const Pictogram = ({ pictogramType, className }: PictogramProps) => {
  return (
    <svg className={className} aria-hidden="true">
      <use
        xlinkHref={`assets/svg/pictogram-symbols.svg#${pictogramType}`}
      ></use>
    </svg>
  );
};

export default Pictogram;
